import { Loader2, Inbox } from "lucide-react";

export function Spinner({ className = "" }) {
  return <Loader2 className={`animate-spin ${className}`} />;
}

export function FullSpinner({ label = "Loading…" }) {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-[#781826]" data-testid="loading-spinner">
      <Loader2 className="w-8 h-8 animate-spin mb-3" />
      <p className="text-sm text-[#605255]">{label}</p>
    </div>
  );
}

export function SkeletonCard() {
  return (
    <div className="mj-card overflow-hidden animate-pulse">
      <div className="aspect-[4/5] bg-[#F1E9DA]" />
      <div className="p-4 space-y-2">
        <div className="h-4 bg-[#F1E9DA] rounded w-2/3" />
        <div className="h-3 bg-[#F1E9DA] rounded w-1/2" />
        <div className="h-3 bg-[#F1E9DA] rounded w-3/4" />
      </div>
    </div>
  );
}

export function Empty({ icon: Icon = Inbox, title, message, action, testid }) {
  return (
    <div className="mj-card p-10 text-center flex flex-col items-center" data-testid={testid || "empty-state"}>
      <div className="w-16 h-16 rounded-full bg-[#FAF3E0] flex items-center justify-center mb-4">
        <Icon className="w-7 h-7 text-[#9E7B1B]" />
      </div>
      <h3 className="font-serif text-xl font-semibold text-[#58111A] mb-1">{title}</h3>
      <p className="text-sm text-[#605255] max-w-sm mb-5">{message}</p>
      {action}
    </div>
  );
}
